// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
var titleFontWeight = '600';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var titleBlockStyles = css({
  justifyContent: 'center',
  fontWeight: titleFontWeight,
  marginTop: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var mainTextStyles = css({
  display: 'inline',
  justifyContent: 'center',
  marginTop: "var(--ds-space-0, 0px)",
  fontSize: '0.75rem',
  textAlign: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var connectButtonStyles = css({
  justifyContent: 'center',
  marginTop: "var(--ds-space-100, 8px)"
});